import Core from '../../Core';
import { toast } from 'react-toastify';
import { CompanyProps } from '../types';
import * as api from '../../../services/api';
import { useNavigate } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import useWindowSize from '../../../hooks/useWindowSize';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import { DefaultMessage } from '../../../utils/defaultMessages';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import {
  Avatar,
  Chip,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  TextField,
} from '@mui/material';
import { MdNoAccounts } from 'react-icons/md';
import DialogComponent from '../../../components/DialogComponent';

export default function Companies(): JSX.Element {
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const [data, setData] = useState<CompanyProps[]>();
  const [dataSearch, setDataSearch] = useState<CompanyProps[]>();
  const [idCompanyToDelete, setIdCompanyToDelete] = useState<string>();
  const [nameCompanyToDelete, setNameCompanyToDelete] = useState<string>();

  const getData = async () => {
    await api
      .get('company/list/')
      .then((response: any) => {
        if (response.status === 200) {
          setData(response.data.content);
          setDataSearch(response.data.content);
        } else {
          toast.error(DefaultMessage.ERROR, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        toast.error(DefaultMessage.ERROR, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  function handleOpenDialog(id: string, name: string) {
    setIdCompanyToDelete(id);
    setNameCompanyToDelete(name);
  }

  const deleteCompany = async () => {
    toast.dismiss();
    toast.loading('Aguarde...', {
      position: toast.POSITION.TOP_RIGHT,
    });

    await api
      .destroy(`company/delete/${idCompanyToDelete}/`)
      .then(async (response: any) => {
        toast.dismiss();
        if (response.status === 204) {
          await getData();
          toast.success('Empresa excluída com sucesso!', {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error(DefaultMessage.ERROR, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error(DefaultMessage.ERROR, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    search(value);
  };

  function search(value: string) {
    setDataSearch(
      data?.filter(
        (item) =>
          item.social_reason.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
          item.fantasy_name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
          item.email.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
          item.cnpj.toLowerCase().indexOf(value.toLowerCase()) > -1,
      ),
    );
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <Core
      withNavbar
      withBlueBar
      path="/new-company"
      label="Clique aqui para cadastrar uma nova empresa"
    >
      <Grid
        container
        direction="column"
        alignContent="center"
        alignItems="center"
        textAlign="center"
        paddingBottom={10}
        paddingX={width > 600 ? 10 : 2}
        gap={2}
      >
        <Chip label="Empresas cadastradas" />
        <TextField
          type="text"
          placeholder="Pesquisar"
          fullWidth
          onChange={handleChangeSearch}
        />
        {
          <List sx={{ width: '90%', bgcolor: 'background.paper' }}>
            {dataSearch?.map((item, index) => (
              <div key={`company-item-${index}`}>
                <ListItem
                  alignItems="flex-start"
                  secondaryAction={
                    <Fragment>
                      <IconButton
                        sx={{ mr: 2 }}
                        edge="end"
                        aria-label="delete"
                        data-testid={`delete-button-${index}`}
                        onClick={() => {
                          localStorage.setItem('selected_company', JSON.stringify(item));
                          navigate(`/users/${item.id}`);
                        }}
                      >
                        <GroupRoundedIcon />
                      </IconButton>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => {
                          handleOpenDialog(item.id, item.social_reason);
                        }}
                      >
                        <DeleteRoundedIcon />
                      </IconButton>
                    </Fragment>
                  }
                >
                  <ListItemAvatar>
                    {new Date(item.contract_end).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) ? (
                      <Avatar sx={{ bgcolor: '#31c48d', color: 'white' }} />
                    ) : (
                      <MdNoAccounts
                        size={48}
                        style={{
                          position: 'relative',
                          left: '-5px',
                          textAlign: 'left',
                        }}
                        color="#f98080"
                      />
                    )}
                  </ListItemAvatar>
                  <ListItemButton
                    data-testid={`item-button-${index}`}
                    onClick={() => {
                      navigate(`/company/${item.id}`);
                    }}
                  >
                    <ListItemText
                      primary={item.social_reason}
                      secondary={
                        <Fragment>
                          <i style={{ color: 'black' }}>{item.cnpj}</i>
                          <br />
                          <i style={{ color: 'black' }}>{item.email}</i>
                          <br />
                          <Chip
                            label={`Vigência do contrato: ${item.contract_start} até ${item.contract_end}`}
                            size="small"
                            variant="outlined"
                            sx={{
                              fontSize: '16px',
                              borderColor:
                                new Date(item.contract_end).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
                                  ? "#31c48d"
                                  : "#f98080",
                              color:
                                new Date(item.contract_end).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
                                  ? "#31c48d"
                                  : "#f98080",
                            }}
                          />
                        </Fragment>
                      }
                    />
                  </ListItemButton>
                </ListItem>
                <Divider variant="inset" component="li" />
              </div>
            ))}
          </List>
        }
      </Grid>
      <DialogComponent permanent={true} action='excluir a empresa' emailUser={nameCompanyToDelete ? nameCompanyToDelete : ''} open={idCompanyToDelete ? true : false} idUser={idCompanyToDelete ? idCompanyToDelete : ''} onClose={() => {
        setIdCompanyToDelete(undefined);
        setNameCompanyToDelete(undefined);
      }} onClickNo={() => {
        setIdCompanyToDelete(undefined);
        setNameCompanyToDelete(undefined);
      }} onClickYes={() => {
        deleteCompany();
        setIdCompanyToDelete(undefined);
        toast.success('Empresa excluída com sucesso!', {
          position: toast.POSITION.TOP_RIGHT,
        });
      }} />
    </Core>
  );
}
